

























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Table } from '@/components/bwaff';
import { CardForm } from '@/components/bwaff';
import moment from 'moment';
import numeral from 'numeral';
import { forEach } from 'lodash';

import config from 'src/config';

const apiBaseURL = config.api.baseURL;

@Component({
  components: {
    CardForm,
    DataTable: Table
  }
})
export default class Invoices extends Vue {
  @Prop() api: any;
  @Prop({
    default:'DD MMMM YYYY'
  }) format: string;

  rows: any[] = [];
  rowsOnPage: number = 10;

  pagination: object = {
    rowsPerPage: this.rowsOnPage
  };

  get statuses(): {[type: string]: { text: string, class: string }} {
    return {
      paid: {
        text: this.t('Paid'),
        class: 'invoices__status--paid'
      },
      payment_due: {
        text: this.t('Payment due'),
        class: 'invoices__status--payment-due'
      },
      not_paid: {
        text: this.t('Not paid'),
        class: 'invoices__status--not-paid'
      },
      voided: {
        text: this.t('Voided'),
        class: 'invoices__status--neutral'
      },
      pending: {
        text: this.t('Pending'),
        class: 'invoices__status--neutral'
      },
    };
  }

  get headers() {
    return [
      {
        text: this.t('Date'),
        align: 'left',
        sortable: false,
        value: 'date'
      },
      {
        text: this.t('Sum'),
        align: 'center',
        sortable: false,
        value: 'total'
      },
      {
        text: this.t('Status'),
        align: 'center',
        sortable: false,
        value: 'status'
      },
      {
        text: this.t('Download'),
        align: 'center',
        sortable: false,
        value: 'download'
      }
    ];
  }



  formatters: any = {
    download: (h: Function, c: any, ctx: any, x: any, s: any) => {
      if (x.download)
        return h('a',
          {
            style: {
              color: this.$colors.green,
              'font-size': '13px'
            },
            attrs: {
              href: `${apiBaseURL}/billing/invoices/${x.id}?accesstoken=${this.$store.state.authToken}`,
              target: '_blank'
            }
          },
          [
            h('ui-icon',
              {
                props: {
                  size: 12,
                  color: this.$colors.green,
                  icon: 'fas fa-file-download',
                },
                style: {
                  'margin-right': '4px',
                  'vertical-align': 'baseline'
                }
              },
            ),
            this.t('Download')
          ]
        )
    },
    total: (h: Function, c: any, ctx: any, x: any, s: any) => {
      const value = numeral(x.total / 100).format('0.00');

      return h('span', {}, value);
    },

    status: (h: Function, c: any, ctx: any, x: any, s: any) => {
      const status = this.statuses[x.status];

      return h('span', {
        class: {
          [status.class]: true
        }
      }, status.text);
    },
  };

  @Watch('api.dataInvoices')
  dataReceived(data: any) {
    this.rows = forEach(data, e => {
      e.date =  moment.unix(e.date).format(this.format);
      e.download = this.formatters;
      return e;
    });
  }
}
